import { ForwardedRef, forwardRef, RefObject, useRef } from 'react'

import TextInput, { TextInputProps } from '../inputs/text.input'
import FieldSet from './field-set'
import { FormFieldProps } from './types'
import { onBlurHandler, onChangeHandler, useRemoveFieldOnUnmount } from './utils'

export type TextFieldProps = TextInputProps & FormFieldProps

const TextField = (
  {
    form,
    name,
    wrapperClassName,
    labelClassName,
    descriptionClassName,
    validators,
    isArrayField,
    arrayFieldName,
    arrayFieldIndex,
    defaultValue,
    onChange,
    onBlur,
    removeFieldOnUnmount,
    ...rest
  }: TextFieldProps,
  ref: ForwardedRef<HTMLInputElement>,
) => {
  const innerRef = useRef<HTMLInputElement>(null)
  useRemoveFieldOnUnmount(form, name, removeFieldOnUnmount)

  const inputRef = ref ?? innerRef

  return (
    <FieldSet
      name={name}
      form={form}
      wrapperClassName={wrapperClassName}
      arrayFieldIndex={arrayFieldIndex}
      arrayFieldName={arrayFieldName}
      isArrayField={isArrayField}
      labelClassName={labelClassName}
      descriptionClassName={descriptionClassName}
      nestedLabelRequiresOffset={Boolean(rest.leftOfInput)}
      inputRef={inputRef as RefObject<HTMLInputElement>}
      {...rest}
    >
      {(hasErrors) => (
        <form.Field name={name} validators={validators} defaultValue={defaultValue}>
          {(field: any) => (
            <TextInput
              {...rest}
              ref={inputRef}
              name={name}
              value={field.state.value as string}
              onBlur={onBlurHandler(field, onBlur)}
              onChange={onChangeHandler<string>(field, onChange)}
              hasErrors={hasErrors}
            />
          )}
        </form.Field>
      )}
    </FieldSet>
  )
}

export default forwardRef<HTMLInputElement, TextFieldProps>(TextField)
